import React, {Component} from 'react'
import ImageGallery from "../../../../common/image/gallery.component.jsx"
import Icon from "../../../../common/icon/icon.component.jsx";
import {FormattedMessage} from "react-intl";
import SectionWrapper from "../../sectionwrapper.component.jsx";

class ProjectImagesContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function(){},
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }
        const hide = this.state.editable ? '' : 'd-none'
        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className="col-12">
                    {this.state.variables.project.images.length > 0 ?
                        <ImageGallery value={this.state.variables.project.images} /> :
                        <div className={hide}>
                            <p className={"section-empty-message m-0 text-left"}>
                                <FormattedMessage
                                    id="templates.sections.content_types.project_images.name"
                                    defaultMessage="Project images"
                                />
                            </p>
                            <p className={"section-empty-message"}>
                                <Icon value={"images"} />
                                <small className={"ml-2"}>
                                    <FormattedMessage
                                        id="templates.sections.project_images.empty_message"
                                        defaultMessage="There is no image in this project"
                                    />
                                </small>
                            </p>
                        </div>
                    }
                </div>
            </SectionWrapper>
        )
    }
}

export default ProjectImagesContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/project-images/section.component.jsx